// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1LLc3","title":"style_title__pFKTv","line":"style_line__25Pqh","arrow":"style_arrow__1TvUg","classes":"style_classes__7wAOe","item":"style_item__14Ek5"};